import React from "react";
import style from "./index.module.scss";
import { ColumnProps } from "antd/lib/table/interface";
import CommonTable from "components/CommonTable";
import MultiLineColumn from "components/MultiLineColumn";
import OverLengthColumn from "components/OverLengthColumn";
import { GroupMemberListItem } from "service/group";

interface TableListProps {
    data: GroupMemberListItem[];
    loading: boolean;
}

export default function TableList({ data, loading }: TableListProps) {
    const columns: ColumnProps<any>[] = [
        {
            title: "序号",
            dataIndex: "index",
            align: "center",
            render: (text, item, index) => index + 1
        },
        {
            title: "班级",
            dataIndex: "className",
            align: "center",
            width: 150,
            render: text => <OverLengthColumn value={text} width={150} />
        },
        {
            title: "组名",
            dataIndex: "groupName",
            align: "center",
            width: 150,
            render: text => <OverLengthColumn value={text} width={150} />
        },
        {
            title: "学生信息",
            dataIndex: "memberNo",
            align: "left",
            render: (val, item) => <MultiLineColumn name={item.name} no={val} />
        },
        {
            title: "参与状态",
            dataIndex: "status",
            align: "center",
            render: text => <div>{text !== "2" ? "未参与" : "已参与"}</div>
        },
        {
            title: "参与时间",
            dataIndex: "partInTimeStr",
            align: "center",
            render: text => <div>{text ? text : "--"}</div>
        },
        {
            title: "小组得分",
            dataIndex: "groupScore",
            align: "center"
        },
        {
            title: "个人得分",
            dataIndex: "memberScore",
            align: "center"
        }
    ];

    return (
        <div className={style.root}>
            <CommonTable
                columns={columns}
                dataSource={data}
                rowKey="id"
                pagination={false}
                loading={loading}
                height="470px"
            />
        </div>
    );
}
